module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "container auth-view-wrapper"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/images/logo.png"),
      "alt": "Reev"
    }
  }), _c('fieldset', [_c('legend', {
    staticClass: "auth-legend"
  }, [_vm._v("Redefinir senha")]), _c('transition-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.apiErrorMessages.length),
      expression: "apiErrorMessages.length"
    }],
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.apiErrorMessages), function(errorMessage) {
    return _c('div', {
      staticClass: "error-message"
    }, [_vm._v(_vm._s(errorMessage))])
  }), 0), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password_reset-password",
      "type": "password",
      "name": "password",
      "placeholder": "Nova senha"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    key: "password",
    staticClass: "help-block text-left"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])], 1), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password_confirmation')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password_confirmation),
      expression: "user.password_confirmation"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password_reset-password_confirmation",
      "type": "password",
      "name": "password_confirmation",
      "placeholder": "Repetir nova senha"
    },
    domProps: {
      "value": (_vm.user.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password_confirmation", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password_confirmation')),
      expression: "errors.has('password_confirmation')"
    }],
    key: "password_confirmation",
    staticClass: "help-block text-left"
  }, [_vm._v(_vm._s(_vm.errors.first('password_confirmation')))])])], 1), _c('button', {
    staticClass: "btn btn-block btn-primary submit-button",
    attrs: {
      "type": "submit",
      "disabled": _vm.errors.any()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Ativar conta")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ea29283e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sessions/reset_password.vue
// module id = 1232
// module chunks = 1